import { ScrollTrigger } from '../gsap/setup';

export function initHomeColorChange() {
  const $services = $('.home-services');
  if (!$services.length) return;

  ScrollTrigger.create({
    trigger: $services[0],
    start: 'top center',
    onEnter: () => {
      document.body.classList.remove('is-dark');
    },
    onLeaveBack: () => {
      document.body.classList.add('is-dark');
    },
  });
}
